import React from 'react';
import { useEvaluationRequestUtils } from '../../../utils/useRecommendation';
import Button from '../../controls/Button';
import BaseModal from '../BaseModal';

import './ReopenRecommendationModal.less';

/**
 *
 * @param {{
 *  show?:boolean;
 *  request?:import('../../../store/reducers/dashboardReducer').TEvaluationRequest;
 *  onClose?(r:boolean):void;
 *  isBusy?:boolean;
 * }} props
 * @returns {React.ReactElement}
 */
const ReopenRecommendationModal = props => {
  const { show, request, onClose, isBusy } = props;
  const evaluation = useEvaluationRequestUtils(request);

  const cancelButtonClickHandler = () => {
    onClose?.(false);
  };

  const confirmButtonClickHandler = async () => {
    onClose?.(true);
  };

  const modalBody = () => {
    return (
      <>
        <p tabIndex={0}>
          If you edit this completed {evaluation.recommendationRequest?.evaluationType}, it will be marked incomplete
          and you must resubmit it. You can edit this {evaluation.recommendationRequest?.evaluationType} if you need to
          make changes, such as uploading a new document, adding more information, or correcting an error.
        </p>
      </>
    );
  };

  const renderControls = () => {
    return (
      <>
        <Button primary onClick={confirmButtonClickHandler} size="large">
          Confirm
        </Button>
        <Button danger onClick={cancelButtonClickHandler} size="large">
          Cancel
        </Button>
      </>
    );
  };

  return (
    <BaseModal
      isBusy={isBusy}
      show={show}
      modalClass={'modal-reopen-recommendation'}
      title={`Are you sure?`}
      body={modalBody()}
      controls={renderControls()}
    />
  );
};

export default ReopenRecommendationModal;
